import React, { PropTypes } from 'react';
import NovoPontoRetanguloBase from './NovoPontoRetanguloBase';
import Point from './Point';

export default class NovoPonto extends NovoPontoRetanguloBase {
	
	componentDidMount() {
		this.setState({
			textoBotao: 'Novo ponto',
			textoLabel: 'Adicionar novo ponto'
		});
	}

	novo() {
		this.props.createPoint({ isCreating: true });
		this.setState({is_lightbox_open: true}); 
	}
	
	cancelar() {
		this.props.removePoint(this.props.points.length-1);
		this.setState({is_lightbox_open: false}); 
	}
	
	finalizar() {
		this.props.setIsCreatingPoint(this.props.points.length-1, false);
	}

	conteudoLightbox() {
		return (
			<div>
				<Point
					isNewPoint
					point={this.props.points.at(-1)}
					index={this.props.points.length-1}
					setLat={this.props.setLat}
					setLng={this.props.setLng}
					removePoint={this.props.removePoint}
					addPointImage={this.props.addPointImage}
					addPointImageWithSrc={this.props.addPointImageWithSrc} 
					removePointImage={this.props.removePointImage}
					removeSavedPointImage={this.props.removeSavedPointImage}
					setPointSrc={this.props.setPointSrc}
					setPointCaption={this.props.setPointCaption}
					setPointLabel={this.props.setPointLabel}
					checkExistance={this.props.checkExistance}
				/>
			</div>
		);
	}
}

NovoPonto.propTypes = {
	points: PropTypes.array.isRequired,
	removePoint: PropTypes.func.isRequired,
	createPoint: PropTypes.func.isRequired,
	setLat: PropTypes.func.isRequired,
	setLng: PropTypes.func.isRequired,
	setPoints: PropTypes.func.isRequired,
	addPointImage: PropTypes.func.isRequired,
	addPointImageWithSrc: PropTypes.func.isRequired,
	removePointImage: PropTypes.func.isRequired,
	removeSavedPointImage: PropTypes.func.isRequired,
	setPointSrc: PropTypes.func.isRequired,
	setPointCaption: PropTypes.func.isRequired,
	setPointLabel: PropTypes.func.isRequired,	
	setIsCreatingPoint: PropTypes.func.isRequired,
	checkExistance: PropTypes.func.isRequired
};


// WEBPACK FOOTER //
// ./src/components/Documents/NovoPonto.js